import React from "react";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Events extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Events._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Name",
				accessor: "name",
				Cell: props => <Link to={"/events/" + props.original.binary_id + '-' + props.original.pkey}>{props.original.name}</Link>
			},
			{
				Header: "Start",
				id: "start",
				width: 160,
				accessor: obj => {
					return moment(obj.start)
						.local()
						.format("MM/DD/YYYY")
				}
			},
			{
				Header: "End",
				id: "end",
				width: 160,
				accessor: obj => {
					return obj.end ? moment(obj.end)
						.local()
						.format("MM/DD/YYYY") : ''
				}
			},
			{
				Header: "Location",
				id: "city",
				accessor: obj => <span>{obj.city}, {obj.state}</span>,
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/events/${props.original._id}`}>
								<Button color="green-meadow" size="sm" block={true}>
									<i className="fa fa-pencil"/>
								</Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Events', "")}
								{this.renderHeaderRight("Events", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
